module.exports = __webpack_public_path__ + "img/core-4.de9e6ad.png";